import workspaceQuery from 'graphql/queries/supplier/VendorRatingWorkspaceQuery.graphql';
import listQuery from 'graphql/queries/supplier/VendorRatingListQuery.graphql';
import instanceQuery from 'graphql/queries/supplier/VendorRatingQuery.graphql';
import defaultQuery from 'graphql/queries/supplier/VendorRatingDefault.graphql';
import mutationQuery from 'graphql/mutations/supplier/VendorRatingMutation.graphql';
import fragment from 'graphql/fragments/supplier/VendorRatingFragment.graphql';

const VendorRating = {
  type: 'VendorRating',
  title: 'Vendor Ratings',
  formUrl: '/Suppliers/VendorRating/Details/',
  formTitle: 'Vendor Ratings',
  workspaceUrl: '/Suppliers/VendorRating/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'description',
  },
  fragment,
  screenReference: 'SUPPLIER_VENDOR_RATING',
};

export default VendorRating;
